import type { ReactNode } from "react";
import { Button, Grid, Typography } from "antd";

import "../styles/PageHeader.css";

const { Text, Title } = Typography;

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actionLabel?: ReactNode;
  onAction?: () => void;
  isbutton?: boolean;
  actions?: ReactNode;
}

export const PageHeader = ({
  title,
  description,
  actionLabel,
  onAction,
  isbutton = true,
  actions,
}: PageHeaderProps) => {
  const screens = Grid.useBreakpoint();

  return (
    <section className="list-page-header">
      <div className="list-page-header-copy">
        <Title level={screens.md ? 1 : 3}>{title}</Title>
        {description && <Text type="secondary">{description}</Text>}
      </div>
      {actions ? (
        <div className="list-page-header-actions">{actions}</div>
      ) : !!isbutton && onAction && (
        <Button
          className="list-page-header-action"
          type="primary"
          size="large"
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </section>
  );
};
